var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasError)?[_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.error))])]:_vm._e(),_vm._v(" "),(_vm.isFree)?[_c('b-button',{class:{
                    'btn-block btn-white btn-slimpad': !_vm.inline,
                    'btn-primary': _vm.inline,
                  },attrs:{"variant":"primary","disabled":_vm.isBusy},on:{"click":_vm.handleEnrol}},[_vm._t("default",function(){return [_vm._v("Take Assessment")]})],2)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }